// Le texte d'un membre : ses retours à la ligne, ses liens cliquables, et les
// personnes qu'il a identifiées.
//
// L'ancienne version fabriquait du HTML : elle échappait le texte, puis y
// réinjectait des balises `<a>` et `<br>`. Ça marchait, mais l'ordre des deux
// opérations était vital — échapper APRÈS avoir ajouté les balises les aurait
// détruites, échapper trop tard aurait ouvert la porte à l'injection. Un
// concours de circonstances à ne jamais se tromper, dans le seul endroit de
// l'application où passe du texte écrit par n'importe qui.
//
// Ici il n'y a plus de HTML du tout : on découpe le texte et on rend des
// éléments. React échappe ce qu'il affiche, par construction. L'erreur n'est
// plus évitée — elle est devenue impossible à écrire.

import { Fragment } from "react";

// Le groupe est capturant : `split` rend alors une alternance
// [texte, lien, texte, lien…], donc les index impairs sont les liens.
const LIEN = /(https?:\/\/[^\s]+)/g;

const echapper = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/**
 * Découpe une ligne sur les personnes identifiées.
 *
 * On ne cherche PAS « tout ce qui ressemble à @quelquechose » : on ne cherche
 * que les noms réellement choisis au moment d'écrire, fournis par `mentions`.
 * Un membre peut taper « @Grâce » sans avoir choisi personne, et deux membres
 * peuvent porter le même nom — deviner mènerait au mauvais profil.
 */
function surLesMentions(ligne, mentions, cle) {
  if (!mentions?.length) return ligneEnLiens(ligne, cle);
  const motif = new RegExp(`(@(?:${mentions.map((m) => echapper(m.nom)).join("|")}))`, "g");
  return ligne.split(motif).map((morceau, i) => {
    if (i % 2 === 0) return <Fragment key={`${cle}-t${i}`}>{ligneEnLiens(morceau, `${cle}-${i}`)}</Fragment>;
    const m = mentions.find((x) => "@" + x.nom === morceau);
    return (
      <a className="mention" href={`#/profil/${m.uid}`} key={`${cle}-m${i}`}>
        {morceau}
      </a>
    );
  });
}

function ligneEnLiens(ligne, cle) {
  return ligne.split(LIEN).map((morceau, i) =>
    i % 2 === 1 ? (
      <a href={morceau} target="_blank" rel="noopener noreferrer" key={`${cle}-${i}`}>
        {morceau}
      </a>
    ) : (
      morceau
    )
  );
}

export default function TexteRiche({ texte = "", mentions }) {
  return texte.split("\n").map((ligne, i) => (
    <Fragment key={i}>
      {i > 0 && <br />}
      {surLesMentions(ligne, mentions, i)}
    </Fragment>
  ));
}
